import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import {
    CreateExpressOrderMethod,
    type CreateExpressOrderResponseSuccess,
    CreateExpressOrderUrl,
} from '@/shared/api/openApi';
import { request } from '@/shared/api/request';

export const api = createApi({
    name: 'entities/order/api/expressApi',
    baseQuery: createBaseQuery(request),
    endpoints: (builder) => {
        return {
            CreateOrder: builder.mutation<CreateExpressOrderResponseSuccess, { query: string }>({
                query: (payload) => {
                    return {
                        url: `${CreateExpressOrderUrl}?${payload.query}`,
                        method: CreateExpressOrderMethod,
                    };
                },
            }),
        };
    },
});

export const createExpressOrder = ({ query }: { query: string }) => api.endpoints.CreateOrder.mutate({ query });
